import React from 'react'
import {Typography, Box} from "@material-ui/core";
import {useTranslation} from "@/langs/useTranslation";
import styles from './index.module.less'
import {IconAndroid, IconWindows} from "@/components/Icon";
import dayjs from "dayjs";
import {IStatus} from "@/containers/ProfileConfig/constant";

const ConfigDetail = ({values, isHistory, systemType="android"}) => {
  const { t } = useTranslation()

  const statusClassName = {
    1: styles.released,
    0: styles.draft,
    2: styles.disabled,
  }

  const statusName = {
    [IStatus.ENABLE]: t({defaultMessage: '已发布'}),
    [IStatus.DISABLE]: t({defaultMessage: '禁用'}),
    [IStatus.DRAFT]: t({defaultMessage: '草稿'}),
  }

  return (
    <div>
      <Typography variant="h5" style={{marginBottom: 32}}>
        {t({defaultMessage: "配置文件详情"})}
      </Typography>
      <Box display="flex" marginBottom={3} alignItems="center">
        <div className={styles.configTip}>
          {t({defaultMessage: '设备类型：'})}
        </div>
        <div className={styles.configContent}>
          {systemType==="android"? "Android": "Windows"}
        </div>
        {systemType==="android"?
          <IconAndroid size={24} color="#00afc6" />:
          <IconWindows size={24} color="#00afc6" />
        }
      </Box>
      <Box display="flex" marginBottom={3} alignItems="center">
        <div className={styles.configTip}>
          {t({defaultMessage: '版本：'})}
        </div>
        <div className={styles.configContent}>
          {values.version || "-"}
        </div>
      </Box>
      { !isHistory && (
        <Box display="flex" marginBottom={3} alignItems="center">
          <div className={styles.configTip}>
            {t({defaultMessage: '状态：'})}
          </div>
          <div className={styles.configContent}>
            {values.status!==undefined?
              (
                <div className={statusClassName[values.status]}>
                  {
                    statusName[values.status]
                  }
                </div>
              ): "-"}
          </div>
        </Box>
      )}
      <Box display="flex" marginBottom={3} alignItems="center">
        <div className={styles.configTip}>
          {t({defaultMessage: '操作人：'})}
        </div>
        <div className={styles.configContent}>
          {values.person || "-"}
        </div>
      </Box>
      <Box display="flex" marginBottom={3} alignItems="center">
        <div className={styles.configTip}>
          {t({defaultMessage: '最近更新时间：'})}
        </div>
        <div className={styles.configContent}>
          {values.lastUpdateTime? dayjs(values.lastUpdateTime).format('YYYY-MM-DD HH:mm:ss'): "-"}
        </div>
      </Box>
    </div>
  )
}

export default ConfigDetail